import React from 'react';
import { Box, Optional, Badge } from '@honda-canada/design-system-react';
import PropTypes from 'prop-types';
import themeStyles from './DealerBadges.style';
import useLanguage from '../../../hooks/useLanguage';
import { useVariant } from '../../../context/VariantContext';
import variantsConfig from '../variantsConfig';

const BadgesContainer = themeStyles.apply(Box, 'BadgesContainer');
const GreenDealer = themeStyles.apply(Box, 'GreenDealer');
const EvDealer = themeStyles.apply(Box, 'EvDealer');

const DealerBadges = ({ greenDealer, evDealer }) => {
  const lang = useLanguage();
  const variant = useVariant();

  const { showGreenDealerProgram } = variantsConfig.getVariantConfig(variant);

  return (
    <Optional when={showGreenDealerProgram && (greenDealer || evDealer)}>
      <BadgesContainer>
        <Optional when={greenDealer}>
          <GreenDealer>
            <Badge name="greenDealer" badgeSize="default" lang={lang} />
          </GreenDealer>
        </Optional>
        <Optional when={evDealer}>
          <EvDealer hasGreenDealer={greenDealer}>
            <Badge name="evDealer" badgeSize="default" lang={lang} />
          </EvDealer>
        </Optional>
      </BadgesContainer>
    </Optional>
  );
};

DealerBadges.propTypes = {
  greenDealer: PropTypes.bool,
  evDealer: PropTypes.bool,
};

export default DealerBadges;
